import React from "react";
import {
  Truck,
  Headphones,
  BadgeDollarSign,
  ThumbsUp,
} from "lucide-react";

const TrustFactors: React.FC = () => {
  const factors = [
    {
      icon: Truck,
      title: "Free Shipping",
      description: "Free shipping over $100",
      color: "text-primary",
      bgColor: "bg-neutral-800",
    },
    {
      icon: Headphones,
      title: "Support",
      description: "Top quality Support",
      color: "text-primary",
      bgColor: "bg-neutral-800",
    },
    {
      icon: BadgeDollarSign,
      title: "Payment on Delivery",
      description: "Pay when you receive your order",
      color: "text-primary",
      bgColor: "bg-neutral-800",
    },
    {
      icon: ThumbsUp,
      title: "Quality Products",
      description: "We Insure Product Quality",
      color: "text-primary",
      bgColor: "bg-neutral-800",
    },
  ];

  return (
    <div className="w-full py-8">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {factors.map((factor, idx) => {
            const Icon = factor.icon;
            return (
              <div
                key={idx}
                className="flex flex-col items-center text-center p-6 rounded-lg border border-neutral-800 hover:border-primary hover:shadow-md transition-all duration-300 bg-neutral-900/50 hover:bg-neutral-900"
              >
                <div className={`${factor.bgColor} p-4 rounded-full mb-4`}>
                  <Icon
                    className={`w-8 h-8 ${factor.color}`}
                    strokeWidth={1.5}
                  />
                </div>
                <h3 className="text-lg font-bold text-white mb-2">
                  {factor.title}
                </h3>
                <p className="text-sm text-neutral-400">{factor.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TrustFactors;
